import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "iconStyle"];
import { Image } from 'foundations-components/transitional/components/Image';
import { filterProps } from 'foundations-components/utils/filterProps';
import { memo } from 'react';
import { ProductIconMap } from '../../constants/merchCards/ProductToIconMap';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductIcon = _ref => {
  let {
      name,
      iconStyle
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const icon = ProductIconMap === null || ProductIconMap === void 0 ? void 0 : ProductIconMap[name];
  const {
    domProps,
    callbackProps
  } = filterProps(rest);
  return icon ? /*#__PURE__*/_jsx(Image, Object.assign({
    src: icon,
    role: "img",
    display: "inline-block"
  }, iconStyle, domProps, callbackProps)) : null;
};
export default /*#__PURE__*/memo(ProductIcon);